import { ALL_ICON_NAMES, Icon as CoreIcon } from '@kodix/one.corvette.icons'
import { useAppConfig } from 'application/configuration'
import React, { FC } from 'react'
import styled from 'styled-components'

import { EcomIconsId } from './types'

export type Props = {
  name: EcomIconsId
  size?: number
  color?: any
}

const getIconName = (name: string, projectName: string | undefined) => {
  const generatedName = !projectName ? name : name + '-' + projectName
  return ALL_ICON_NAMES.includes(generatedName) ? generatedName : name
}

export const Icon: FC<Props> = ({ name, size = 1, color = '' }) => {
  const projectName = useAppConfig().projectName?.toLowerCase()
  return (
    <IconComponent size={size} color={color || ''}>
      <CoreIcon name={getIconName(name, projectName)} size={size * 24 + 'px'} />
    </IconComponent>
  )
}

const IconComponent = styled.div<{ size: number; color?: string }>(
  ({ size, theme, color }) => `
    display:inline-flex;
    align-items:center;
    justify-content: center;
    width:${size * 24}px;
    height:${size * 24}px;
    font-size:${size * 24}px;
    color: ${color}
`
)
